import { Link } from 'react-router-dom'
import styles from './NotFoundPage.module.css'

export function NotFoundPage() {
  return (
    <div className={styles.container}>
      <div className={styles.glow} aria-hidden="true" />
      <div className={styles.content}>
        <div className={styles.badge}>404</div>
        <h1 className={styles.title}>Page Not Found</h1>
        <p className={styles.desc}>
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className={styles.button} id="not-found-home-btn">
          Return to Player
        </Link>
      </div>
    </div>
  )
}
